import React from 'react'
import { Alert, Typography } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line import/no-cycle
import { IChargedPriceForFlatsItem } from '../../../reducers/payslips/actions'

const { Title, Text } = Typography

interface Props {
	jobs: IChargedPriceForFlatsItem[]
}

const MissingJobFieldsSummary: React.FC<Props> = ({ jobs }) => {
	const { t } = useTranslation('pages')

	const missingPriceCount = jobs.filter((j) => j.priceFlatPerMonthMissingError).length
	const missingFlatsCount = jobs.filter((j) => j.missingFlatCountError).length

	if (missingPriceCount === 0 && missingFlatsCount === 0) {
		return null
	}

	return (
		<div style={{ marginTop: 24, marginBottom: 24 }}>
			<Title level={5} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
				<ExclamationCircleOutlined style={{ color: 'orange' }} />
				{t('pages:Chýbajúce údaje')}
			</Title>

			<Alert
				type="warning"
				message={
					<div>
						{missingFlatsCount > 0 && (
							<Text>
								{t('pages:Nevyplnený počet bytov')}: <strong>{missingFlatsCount}</strong>
								<br />
							</Text>
						)}
						{missingPriceCount > 0 && (
							<Text>
								{t('pages:Nevyplnená cena za byt')}: <strong>{missingPriceCount}</strong>
							</Text>
						)}
					</div>
				}
			/>
		</div>
	)
}

export default MissingJobFieldsSummary
